import moment from "moment";
import React, { Component } from "react";
import FlexView from "react-flexview";
import SimpleButton from "../../../../../../modules/commons/SimpleButton";
import SimpleDataTable from "../../../../../../modules/SimpleDataTable";
import SimpleDDL from "../../../../../../modules/SimpleDDL";
import {
  monthOptions,
  yearOptions,
} from "../../../dashboardLevelMekanikSA/dasboardLaporanHarianPartByMekanikdanSA/config";
import {
  buildSheetFromConfig,
  CONSTANT_NAME,
  serviceTableConfig,
  unitEntriTableConfig,
  unitServiceTableConfig,
} from "./config";
import { fetchDataAsync } from "../../../../../../Services/Utils";
import Api from "../../../../../../Services/Api";
import { HttpStatus } from "../../../../../common/Constants";
import { mapToObjectDDL } from "../../../../../common/mapper";
import { saveAs } from "file-saver";
// type = unit_entri || service || unit_service
export default class LaporanMTD extends Component {
  constructor(props) {
    super(props);
    this.currentMonth = Number(moment().format("MM"));
    this.currentYear = Number(moment().format("YYYY"));
    this.state = {
      month: monthOptions.find((item) => item.value === this.currentMonth),
      year: yearOptions.find((item) => item.value === this.currentYear),
      dataTable: [],
      config: [],
      mechanicName: null,
      mechanicOptions: [],
    };
  }

  componentDidMount() {
    const { type } = this.props;

    this.setState({
      config:
        type === "service"
          ? serviceTableConfig
          : type === "unit_entri"
            ? unitEntriTableConfig
            : unitServiceTableConfig,
    });

    if (type === "service") {
      this.fetchDataMechanic();
    } else {
      this.fetchData();
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const currCabang = this.props.kodeCabang?.value;
    const prevCabang = prevProps.kodeCabang?.value;
    if (currCabang !== prevCabang) {
      if (this.props.type === "service") {
        this.fetchDataMechanic();
      } else {
        this.fetchData();
      }
    }
  }

  handleChangeSearchValue = (name, value) => {
    this.setState((prevValue) => ({
      ...prevValue,
      [name]: value,
    }));
  };

  handleSearch = () => {
    this.fetchData();
  };

  fetchData = () => {
    const { type } = this.props;
    if (type === "service") {
      return this.fetchDataServiceMTD();
    }
    if (type === "unit_entri") {
      return this.fetchDataUnitEntriMTD();
    }
    if (type === "unit_service") {
      return this.fetchDataUnitServiceMTD();
    }
  };

  fetchDataMechanic = async () => {
    const { setError, onTriggerLoading, kodeCabang } = this.props;
    onTriggerLoading();

    const res = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_MASTER_DATA")
        .getMechanicForDropDownListDashboard,
      setError: setError,
      menuName: "Dashboard Kabeng Keatas - Laporan Servis MTD",
      args: [kodeCabang?.value],
    });

    onTriggerLoading();
    if (res.ok && res.data.status === HttpStatus.SUCCESS) {
      const data = res?.data?.data?.map((item) =>
        mapToObjectDDL(item.mechanicName, item.idEmployee),
      );
      this.setState(
        {
          mechanicOptions: data,
          mechanicName: data[0],
        },
        () => {
          this.fetchData();
        },
      );
    }
  };

  fetchDataServiceMTD = async () => {
    const { setError, onTriggerLoading, kodeCabang } = this.props;
    const { year, month, mechanicName } = this.state;

    if (!kodeCabang?.value) return;
    onTriggerLoading();

    const res = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_REPORT_DTO").getLaporanServisMTDH23,
      setError: setError,
      menuName: "Dashboard Kabeng Keatas - Laporan Servis MTD",
      args: {
        listCabang: [kodeCabang?.value],
        year: year?.value,
        month: month?.value,
        mechanicEmployeeId: mechanicName?.value,
      },
    });

    onTriggerLoading();

    if (res.ok && res.data.status === HttpStatus.SUCCESS) {
      const data = res.data.data || {};
      this.setState({
        dataTable: Object.entries(data).map(([key, value]) => ({
          name: CONSTANT_NAME[key] || "",
          ...value,
        })),
      });
    }
  };

  fetchDataUnitServiceMTD = async () => {
    const { setError, onTriggerLoading, kodeCabang } = this.props;
    const { year, month } = this.state;
    const userId = localStorage.getItem("userId");

    if (!kodeCabang?.value) return;
    onTriggerLoading();

    const res = await fetchDataAsync({
      asyncFn:
        Api.create("NAGAMAS_REPORT_DTO").getLaporanUnitServiceMTDByMechanicH23,
      setError: setError,
      menuName: "Dashboard Kabeng Keatas - Laporan Unit Servis MTD",
      args: {
        kodeCabang: kodeCabang?.value,
        year: year?.value,
        month: month?.value,
        type: "KABENG",
        idUser: userId,
      },
    });

    onTriggerLoading();

    if (res.ok && res.data.status === HttpStatus.SUCCESS) {
      const data = res.data.data || [];
      this.setState({
        dataTable: data,
      });
    }
  };

  fetchDataUnitEntriMTD = async () => {
    const { setError, onTriggerLoading, kodeCabang } = this.props;
    const { year, month } = this.state;

    if (!kodeCabang?.value) return;
    onTriggerLoading();

    const res = await fetchDataAsync({
      asyncFn:
        Api.create("NAGAMAS_REPORT_DTO").getLaporanUnitEntriMTDByMekanikH23,
      setError: setError,
      menuName: "Dashboard Kabeng Keatas - Laporan Unit Entri MTD by Mekanik",
      args: {
        kodeCabang: kodeCabang?.value,
        year: year?.value,
        month: month?.value,
        employeeId: null,
      },
    });

    onTriggerLoading();

    if (res.ok && res.data.status === HttpStatus.SUCCESS) {
      const data = res.data.data || [];
      this.setState({
        dataTable: data,
      });
    }
  };

  handlePrint = async () => {
    const { onTriggerLoading, type, setError } = this.props;
    const { dataTable, config } = this.state;

    const titleMap = {
      service: "Laporan Servis MTD",
      unit_entri: "Laporan Unit Entri MTD By Mekanik",
      unit_service: "Laporan Unit Servis MTD By Mekanik",
    };

    const title = titleMap[type];
    const fileName = title.replace(/\s+/g, "_");

    const reqBody = {
      filename: fileName,
      sheets: [
        buildSheetFromConfig({
          title,
          config,
          data: dataTable,
        }),
      ],
    };

    onTriggerLoading();

    const res = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_REPORT").generateExcelFromPayload,
      setError,
      menuName: `Dashboard Kabeng Keatas - ${title}`,
      args: reqBody,
    });

    onTriggerLoading();

    if (res.ok) {
      const blob = new Blob([res.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      saveAs(blob, `${fileName}.xlsx`);
    }
  };

  render() {
    const { month, year, dataTable, config, mechanicOptions, mechanicName } =
      this.state;
    const { type } = this.props;
    return (
      <React.Fragment>
        <FlexView
          style={{ gap: "20px", alignItems: "center" }}
          className="margin-bottom-20px"
        >
          <SimpleDDL
            id="select_options_month"
            box="search"
            name="month"
            containerclassname="width width-250px"
            placeholder="Bulan"
            menuPosition="fixed"
            options={monthOptions}
            value={month}
            onChange={(value, { name }) =>
              this.handleChangeSearchValue(name, value)
            }
          />
          <SimpleDDL
            id="select_options_year"
            box="search"
            name="year"
            containerclassname="width width-250px"
            placeholder="Tahun"
            menuPosition="fixed"
            options={yearOptions}
            value={year}
            onChange={(value, { name }) =>
              this.handleChangeSearchValue(name, value)
            }
          />
          {type === "service" && (
            <SimpleDDL
              id="select_mechanic"
              box="search"
              name="mechanicName"
              isClearable
              containerclassname="width width-250px"
              placeholder="Mekanik"
              menuPosition="fixed"
              options={mechanicOptions}
              value={mechanicName}
              onChange={(value, { name }) =>
                this.handleChangeSearchValue(name, value)
              }
            />
          )}
          <SimpleButton
            styles={{ marginBottom: "15px" }}
            onClick={this.handleSearch}
          >
            Cari
          </SimpleButton>
        </FlexView>
        <SimpleDataTable
          data={dataTable}
          columns={config}
          options={{ pagination: false }}
        />
        <FlexView hAlignContent="right" className="margin-top-20px">
          <SimpleButton text="CETAK" onClick={() => this.handlePrint()} />
        </FlexView>
      </React.Fragment>
    );
  }
}
